<template>
  <info
    v-if="step === 1"
    :id="id"
    v-bind="$attrs"
    @save="onSave"
    :bindMap="bindMap"
    @next="$emit('next')" />
  <relations
    v-else-if="step === 2"
    :id="id"
    v-bind="$attrs"
    :getUsers="getUsers"
    :isEdit="isEdit"
    :dataPermissionCode="dataPermissionCode"
    :evaluatorDataPermission="evaluatorDataPermission"
    :functionCode="functionCode"
    @next="$emit('next')"
    @prev="onPrev"
  />
   <!-- 发布评估 -->
  <publish
    v-else
    v-bind="$attrs"
    :can-publish="canPublish"
    :can-save="canSave"
    :id="id"
    no-timing
    @save="$emit('save')"
    @prev="$emit('prev')"
  />
</template>
<script>
import Info from './info';
import Relations from './relations.vue';
import Publish from '../publish';

export default {
  components: {
    Info,
    Relations,
    Publish
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      default: 0
    },
    canPublish: {
      type: Boolean,
      default: false
    },
    canSave: {
      type: Boolean,
      default: true
    },
    // 绑定地图方法
    bindMap: {
      type: Function,
      default: () => {}
    },
    // 选人方法
    getUsers: {
      type: Function,
      default: () => {}
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_addassessor_extent' /* 岗位地图-测评管理-人员管理选人 */
    },
    functionCode: {
      type: String,
      default: ''
    },
    evaluatorDataPermission: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent'
    }
  },
  data() {
    return {
      isEdit: !!this.id
    };
  },
  methods: {
    onSave(id) {
      this.isEdit = false;
      this.$emit('update:id', id);
    },
    onPrev() {
      this.isEdit = true;
      this.$emit('prev');
    }
  }
};
</script>